// import external dependencies
import 'jquery';

import common from './routes/common';
common.init()

import menu from './menu';
menu.init();

import modals from './modal'
modals.init()

import mortgage from './calculators/mortgage';
mortgage.init();

import refinance from './calculators/refinance';
refinance.init();

import accordion from './calculators/accordion';
accordion.init();

import amortization from './calculators/amortization';
amortization.init();

import multiStep from './calculators/multiStep';
multiStep.init();

import carousel from './carousel';
carousel.init();

import carouselHome from './carousel/home-slider';
carouselHome.init();

import form from './form';
form.init();

import blog from './blog';
blog.init();

import team from './team';
team.init();

import contact from './contact';
contact.init();

import wwu from './contact/work-with-us';
wwu.init();

import heloc from './contact/heloc';
heloc.init();

import blogForm from './contact/blogForm';
blogForm.init();

import UTMTracking from './tracking';
UTMTracking.init();

import initSiteMotion from './animations/site-motion';
initSiteMotion()

import initBubbles from './home/bubbles';
initBubbles()

import { initAccordion } from './accordion';
initAccordion()

// TODO - move all this to a separate file
import Flickity from 'flickity'
const reviews = document.querySelector('.rplg-reviews');
if (reviews) {
  function setupTestimonialFlickity() {
    let testimonialFlickity = new Flickity(document.querySelector('.rplg-reviews'), {
      groupCells: window.innerWidth <= 899 ? false : 2,
      cellAlign: 'left',
      contain: true,
      pageDots: false,
    });

    return testimonialFlickity;
  }

  let testimonialResize;
  let testimonialFlickity = setupTestimonialFlickity()

  window.addEventListener('resize', () => {
    clearTimeout(testimonialResize)
    testimonialResize = setTimeout(() => {
      if (testimonialFlickity) {
        testimonialFlickity.destroy()
      }

      testimonialFlickity = setupTestimonialFlickity()
    })
  })
}

window.addEventListener('load', () => {
  [...document.querySelectorAll('.js-chat-btn')].forEach((chatBtn) => {
    chatBtn.addEventListener('click', (event) => {
      event.preventDefault()

      if (typeof window.LC_API !== 'undefined') {
        window.LC_API.open_chat_window()
      }
    })
  })
})

const zipElements = document.querySelectorAll('.zip-element')

var autocomplete;
function initialize() {
  if (!zipElements) {
    return;
  }

  zipElements.forEach((zipElement) => {
  autocomplete = new google.maps.places.Autocomplete(
    /** @type {HTMLInputElement} */
    (zipElement.querySelector('.zip-code-lookup')),
    { types: ['address'] });
  google.maps.event.addListener(autocomplete, 'place_changed', function () {

  });
})
}

if (typeof google === 'undefined') {
  window.addEventListener('load', () => {

    initialize();

  })
}


